import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Box
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useGetAllTransactions } from "../../api/hooks/useSubscription";
import type { SubscriptionTransaction } from "../../api/types/subscription.types";

const ManageTransaction = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const { data: transactionData, isLoading } = useGetAllTransactions({
    search: debouncedSearchTerm,
    page: 1,
    limit: 100, // Fetching a larger set for now
  });

  const transactions = (transactionData?.data as any)?.list || [];

  return (
    <>
      <div className="main_title">
        <h1>Manage Revenue</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Revenue
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              value={searchTerm}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
              onCross={() => setSearchTerm("")}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Transactions..."
            />
          </div>
        </div>

        {/* Transaction Table */}
        <TableContainer className="table_container">
          <Table className="custom_table">
            <TableHead>
              <TableRow>
                <TableCell>Transaction ID</TableCell>
                <TableCell>Subscription Plan</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : transactions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                    No transactions found.
                  </TableCell>
                </TableRow>
              ) : (
                transactions.map((txn: SubscriptionTransaction) => (
                  <TableRow key={txn._id}>
                    <TableCell>{txn.stripeTransactionId || "--"}</TableCell>
                    <TableCell>{txn.plan?.name || "--"}</TableCell>
                    <TableCell>
                      <Box>
                        <div>{txn.user?.fullName || "N/A"}</div>
                        <div style={{ fontSize: "0.8rem", color: "gray" }}>{txn.user?.email}</div>
                      </Box>
                    </TableCell>
                    <TableCell>${txn.totalAmount?.toFixed(2) || "0.00"}</TableCell>
                    <TableCell>{txn.createdAt ? new Date(txn.createdAt).toLocaleDateString() : "--"}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageTransaction;
